import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import { catchAll } from '@sorare/routing';
import { Centered } from '@sorare/core/src/atoms/layout/Centered';
import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  ANY_SPORT_SERIES_PLAY,
  ANY_SPORT_SERIES_SQUAD,
  ANY_SPORT_SERIES_MARKET,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { matchAnySportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const Root = styled(Vertical).attrs({ gap: 0 })<{ $scrollPercentage: number }>`
  isolation: isolate;
  &:before {
    z-index: -1;
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background: rgba(var(--c-rgb-black), 0.8);
    opacity: ${({ $scrollPercentage }) => $scrollPercentage};
  }
`;

const PageHeaderTitle = styled(SBHorizontal)`
  width: 100%;
  &:empty {
    display: none;
  }
`;

const StyledHorizontal = styled(Centered)`
  padding: var(--unit) var(--double-unit);
`;

const PageHeaderCenteredItem = styled.div`
  display: flex;
`;

export const TransparentMobileWebAppHeader = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const {
    flags: { useColorsMarket },
  } = useFeatureFlags();
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrollPercentage(
        Math.min(
          1,
          Number((window.scrollY / (ref.current?.clientHeight || 1)).toFixed(2))
        )
      );
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // For series play page and squad page, we use the SeriesBoardHeader
  // For colors market page, we use the SetMarketHeader
  if (
    matchAnySportPath(catchAll(ANY_SPORT_SERIES_PLAY), pathname) ||
    matchAnySportPath(catchAll(ANY_SPORT_SERIES_SQUAD), pathname) ||
    (useColorsMarket &&
      matchAnySportPath(catchAll(ANY_SPORT_SERIES_MARKET), pathname))
  ) {
    return null;
  }

  return (
    <Root ref={ref} $scrollPercentage={scrollPercentage}>
      <StyledHorizontal left={<PageHeaderTitle id="page-header-title" />}>
        <PageHeaderCenteredItem id="page-header-centered-item" />
      </StyledHorizontal>
      <div id="page-header-second-row" />
    </Root>
  );
};
